import React from 'react';

import "./css/app.css"
import "./css/navbar.css";
import "./css/hero.css";
import "./css/banner.css";
import "./css/rooms.css"

import Home from './pages/Home';
import Rooms from './pages/Rooms';
import SingleRoom from './pages/SingleRoom';
import About from './pages/About'
import Error from './pages/Error';
import {Route, Switch } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer"; 

function App() {
  return (
   <>
    <Navbar/>
    <Switch>
      <Route exact path="/" component={Home}/>
      <Route exact path="/rooms" component={Rooms}/>
      <Route exact path="/rooms/:slug" component={SingleRoom}/>
      <Route exact path="/about" component={About}/>
      <Route component={Error}/>
    </Switch>
    <Footer/>
  </>
  );
}

export default App;
